import { Transforms, Range, Editor, Path } from 'slate';
import isUrl from 'is-url';

import HelptapEditor from '../../helpers';
/**
 * 
 * TODO: Clean up needed
 * 
 * */

export function withURLs(editor) {
  const { insertText } = editor;

  editor.insertText = function _insertText(text) {

    const { selection } = editor;
    if (text === ' ') {
      if (selection && Range.isCollapsed(selection)) {
        const [node, path] = Editor.node(editor, selection);
        const text = node.text;

        const words = text.split(/\s+/); // Split by spaces or punctuation
        const lastWord = words[words.length - 1];

        if (isUrl(lastWord)) {
          const lastWordStartOffset = text.lastIndexOf(lastWord);
          const lastWordEndOffset = lastWordStartOffset + lastWord.length;

          // Create points for the start and end of the last word
          const anchor = { path, offset: lastWordStartOffset };
          const focus = { path, offset: lastWordEndOffset };

          // Create a range covering the last word
          const range = { anchor, focus };

          // Set the selection to the last word
          Transforms.wrapNodes(editor, HelptapEditor.link.buildNode({
            url: lastWord
          }), { split: true, at: range });
          Transforms.select(editor, {
            anchor: {
              path: Path.next(Path.next(range.focus.path)),
              offset: 0
            },
            focus: {
              path: Path.next(Path.next(range.focus.path)),
              offset: 0
            }
          });

          // Now insert the space outside the link node
          Transforms.insertText(editor, ' ');
          return;
        }
      }
    }
    insertText(text);
  };

  return editor;
};

function wrapLink(editor, url) {
  const { selection } = editor;
  const isCollapsed = selection && Range.isCollapsed(selection);

  if (isCollapsed) {
    Transforms.insertNodes(editor, HelptapEditor.link.buildNodeV2(url));
    Transforms.select(editor, {
      anchor: {
        path: Path.next(Path.next(selection.focus.path)),
        offset: 0
      },
      focus: {
        path: Path.next(Path.next(selection.focus.path)),
        offset: 0
      }
    });
    Transforms.insertText(editor, '');
  } else {
    Transforms.wrapNodes(
      editor, HelptapEditor.link.buildNode({ url }), { split: true }
    );
    Transforms.insertText(editor, url);
    Transforms.collapse(editor, { edge: 'end' });
  }
};

export function withPastedURLs(editor) {

  const { insertData } = editor;

  editor.insertData = function _insertData(data) {

    const text = data.getData('text/plain');
    if (isUrl(text)) {
      wrapLink(editor, text);
    } else {
      insertData(data);
    }

  };

  return editor;

};